import type { PermissionCode } from '@fas/types';
import { useAuthStore } from './auth-store';

export function hasAny(permissions: readonly string[] | undefined, codes: readonly PermissionCode[]): boolean {
  if (!permissions || codes.length === 0) return false;
  return codes.some((c) => permissions.includes(c));
}

/**
 * UI gating only — the API enforces every permission server-side. Hiding controls here
 * simply avoids offering actions the user cannot perform.
 */
export function useCan(...codes: PermissionCode[]): boolean {
  const permissions = useAuthStore((s) => s.me?.permissions);
  return hasAny(permissions, codes);
}

export function useMe() {
  return useAuthStore((s) => s.me);
}
